if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Prevent the ModalDialog pointerup-to-close handler from firing on nav/thumb buttons
        this.querySelectorAll('.product-media-modal__nav, .product-media-modal__thumb').forEach((el) => {
          el.addEventListener('pointerup', (e) => e.stopPropagation());
        });

        this.querySelector('.product-media-modal__nav--prev')
          ?.addEventListener('click', () => this.navigate(-1));
        this.querySelector('.product-media-modal__nav--next')
          ?.addEventListener('click', () => this.navigate(1));
        this.querySelectorAll('.product-media-modal__thumb').forEach((thumb) => {
          thumb.addEventListener('click', () => this.showMediaById(thumb.dataset.mediaId));
        });
        this.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });

        this.bindGestures();
      }

      // Răsfoire fără săgeți: swipe pe telefon, rotița sau trackpad-ul pe
      // calculator. Săgețile, miniaturile și tastele rămân neatinse.
      bindGestures() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        // --- swipe, doar cu degetul ---------------------------------------
        // Doar `touch`/`pen`. Cu mouse-ul nu se poate: ModalDialog închide
        // fereastra la `pointerup` de mouse (global.js, linia 610), deci o
        // tragere cu mouse-ul ar închide galeria în loc s-o răsfoiască.
        let x0 = 0;
        let y0 = 0;
        let t0 = 0;
        let tracking = false;

        content.addEventListener(
          'pointerdown',
          (e) => {
            if (e.pointerType === 'mouse') return;
            tracking = true;
            x0 = e.clientX;
            y0 = e.clientY;
            t0 = Date.now();
          },
          { passive: true }
        );

        content.addEventListener('pointercancel', () => {
          tracking = false;
        }, { passive: true });

        content.addEventListener(
          'pointerup',
          (e) => {
            if (!tracking) return;
            tracking = false;

            const dx = e.clientX - x0;
            const dy = e.clientY - y0;

            // Prea lent înseamnă că degetul a stat pe loc, nu a tras.
            if (Date.now() - t0 > 800) return;
            // Prag de 40px, iar mișcarea trebuie să fie clar orizontală,
            // altfel o atingere tremurată ar sări peste o poză.
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

            this.navigate(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );

        // --- rotiță și trackpad, pe calculator -----------------------------
        // `.product-media-modal__content` are `overflow: hidden`, deci rotița
        // nu derulează nimic — o folosim ca să trecem de la o poză la alta.
        // Zăvorul de 400 ms face ca o mișcare de trackpad, care trimite zeci de
        // evenimente, să însemne un singur pas, nu zece.
        let wheelLock = 0;
        content.addEventListener(
          'wheel',
          (e) => {
            const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
            if (Math.abs(delta) < 4) return;

            const now = Date.now();
            if (now - wheelLock < 400) return;
            wheelLock = now;

            this.navigate(delta > 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      // Pozele ascunse de filtrarea pe culoare (`aperte-media-hidden`, pus de
      // aperte-variant-media.js) nu intră în răsfoire. Fără asta, un pas putea
      // cădea pe o poză cu `display: none` și galeria rămânea goală — se
      // întâmpla și înainte, cu săgețile, la produsele cu mai multe culori.
      mediaItems() {
        return [...this.querySelectorAll('.product-media-modal__content [data-media-id]')].filter(
          (el) => !el.classList.contains('aperte-media-hidden')
        );
      }

      navigate(dir) {
        const items = this.mediaItems();
        if (items.length < 2) return;
        const active = this.querySelector('.product-media-modal__content [data-media-id].active');
        const idx = active ? items.indexOf(active) : 0;
        const next = items[(idx + dir + items.length) % items.length];
        this.showMediaById(next.dataset.mediaId);
      }

      showMediaById(mediaId) {
        this.mediaItems().forEach((el) => el.classList.remove('active'));
        const target = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);
        if (!target) return;
        target.classList.add('active');

        if (target.nodeName === 'DEFERRED-MEDIA') {
          const tmpl = target.querySelector('template');
          if (tmpl?.content?.querySelector('.js-youtube')) target.loadContent();
        }

        this.querySelectorAll('.product-media-modal__thumb').forEach((t) => {
          t.classList.toggle('active', t.dataset.mediaId === mediaId);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.showMediaById(mediaId);
      }
    }
  );
}
